import { render, staticRenderFns } from "./InterfaceBalance.vue?vue&type=template&id=a63ea972&scoped=true&"
import script from "./InterfaceBalance.vue?vue&type=script&lang=js&"
export * from "./InterfaceBalance.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceBalance.vue?vue&type=style&index=0&id=a63ea972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63ea972",
  null
  
)

export default component.exports